import { useMantineTheme } from '@mantine/core';
import { useDebouncedValue, useResizeObserver } from '@mantine/hooks';
import { useEffect, useState } from 'react';

// Custom hook for chart container and dimensions
export function useChartContainer() {
	const theme = useMantineTheme();
	const [containerRef] = useResizeObserver<HTMLDivElement>();
	const [rawWidth, setRawWidth] = useState(0);
	const [rawHeight, setRawHeight] = useState(0);

	// Get the current width from the container
	useEffect(() => {
		if (containerRef.current) {
			const width = containerRef.current.clientWidth;
			if (width > 0) {
				setRawWidth(width);
			}

			const height = containerRef.current.clientHeight;
			if (height > 0) {
				setRawHeight(height);
			}
		}
	}, [containerRef.current?.clientWidth, containerRef.current?.clientHeight]);

	// Debounce the width to prevent excessive re-renders
	const [chartWidth] = useDebouncedValue(rawWidth, 150);
	const [chartHeight] = useDebouncedValue(rawHeight, 150);

	return {
		containerRef,
		chartWidth: chartWidth > 0 ? chartWidth : undefined,
		chartHeight: chartHeight > 0 ? chartHeight : undefined,
		theme,
	};
}
